import React, { useState, useEffect } from 'react';
import './App.css';
import { MenuItem, Select, FormControl, Card, CardContent } from '@material-ui/core';
import InfoBox from './components/InfoBox/InfoBox';
import Map from './components/Map/Map';
import Table from './components/Table/Table';
import { sortData, preetyPrintStat } from './utilities'
import LineGraph from './components/LineGraph/LineGraph'
import 'leaflet/dist/leaflet.css';

function App() {

  const [ countries, setCountries ] = useState([]);
  const [ country, setCountry ] = useState('worldwide');
  const [ countryInfo, setCountryInfo ] = useState({});
  const [ tableData, setTableData ] = useState([]);
  const [ mapCenter, setMapCenter ] = useState({lat: 34.80746, lng: -40.4796});
  const [ mapZoom, setMapZoom ] = useState(3)
  const [ mapCountries, setMapCountries ] = useState([])
  const [ casesType, setCasesType ] = useState('cases');

  useEffect(() => {

    fetch('https://disease.sh/v3/covid-19/all')
    .then(response => response.json())
    .then((data) => {
      setCountryInfo(data)
      });

    const getCountriesData = async () => {
      await fetch ("https://disease.sh/v3/covid-19/countries")
      .then((response) => response.json())
      .then((data) => {
        const countries = data.map((country) => ({
          name: country.country,
          value: country.countryInfo.iso2
        }));

        const sortedData = sortData(data)
        setTableData(sortedData)
        setCountries(countries);
        setMapCountries(data)
      })
    }

    getCountriesData();
  }, [])

  const handleSetCountry = async (event) => {
    const countryCode = event.target.value;

    const URL = countryCode === 'worldwide'
    ? 'https://disease.sh/v3/covid-19/all'
    : `https://disease.sh/v3/covid-19/countries/${countryCode}`;

    await fetch(URL)
    .then(response => response.json())
    .then((data) => {
      setCountry(countryCode);
      setCountryInfo(data)
      try {
        setMapCenter([data.countryInfo.lat, data.countryInfo.long])
        setMapZoom(5)
      } catch (error) {
        setMapCenter({lat: 34.80746, lng: -40.4796})
        setMapZoom(3)
      }
    })
  }

  const {
    todayCases,
    todayRecovered,
    todayDeaths,
    cases,
    recovered,
    deaths
  } = countryInfo

  return (
    <div className="app">
    <div className="app__left">
        <div className="app__header">
          <a href=""><h1>COVID-19 CASES TRACKER</h1></a>
          <FormControl className="app__dropdown">
            <Select variant="outlined" onChange={handleSetCountry} value={country}>
              <MenuItem value="worldwide">Worldwide</MenuItem>
              {countries.map(country => (
                <MenuItem value={country.value}>{country.name}</MenuItem>
              ))}
            </Select>
        </FormControl>
        </div>
        <div className="app__stats">
          <InfoBox
            color={'#cc1034'}
            active={casesType === 'cases'}
            onClick={e => setCasesType('cases')}
            title="Coronavirus cases"
            cases={preetyPrintStat(todayCases)}
            total={preetyPrintStat(cases, true)}
            />
          <InfoBox
              color={'yellowgreen'}
              active={casesType === 'recovered'}
              onClick={e => setCasesType('recovered')}
              title="Recovered"
              cases={preetyPrintStat(todayRecovered)}
              total={preetyPrintStat(recovered, true)}
          />
          <InfoBox
            color={'black'}
            active={casesType === 'deaths'}
            onClick={e => setCasesType('deaths')}
            title="Cases"
            cases={preetyPrintStat(todayDeaths)}
            total={preetyPrintStat(deaths, true)}
          />
        </div>
        <Map
          casesType={casesType}
          countries={mapCountries}
          center={mapCenter}
          zoom={mapZoom}
        />
      </div>
      <Card className="app__right">
       <CardContent>
        <h3>Live cases by country</h3>
        <Table countries={tableData} />
        <h3 className="app__graphTitle">
          Worldwide new {casesType}
        </h3>
        <LineGraph className="app__graph" casesType={casesType}/>
       </CardContent>
      </Card>
    </div>
  );
}

export default App;
